var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FDDC3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.44727C9.46223 7.44727 7 9.39388 7 11.795C7 13.3581 8.04343 14.728 9.60946 15.4944C9.49423 15.9239 9.19278 17.05 9.13284 17.2909C9.05777 17.59 9.24225 17.586 9.36271 17.5057C9.45699 17.4428 10.8694 16.482 11.4793 16.0677C11.8098 16.1166 12.1514 16.1427 12.5 16.1427C15.5378 16.1427 18 14.1961 18 11.795C18 9.39388 15.5378 7.44727 12.5 7.44727Z",
    fill: "#3B1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKakao);
export default __webpack_public_path__ + "static/media/icon_kakao.2496d9d9f88de725b93494292340b316.svg";
export { ForwardRef as ReactComponent };